module.exports = __webpack_public_path__ + "img/album07_09.ad3f509c.jpg";